import React, {Component} from "react";
import Header4 from "../../Header/Header4";
import "./index.css";
import {Button, message, Layout, Menu, Tooltip, Modal} from "antd";
import {connect} from "react-redux";

import {getAllSimulationData,} from "../UserCenter/components/MyOrder/actions";
import {DownloadOutlined, FilePdfOutlined} from "@ant-design/icons";

const {Header, Footer, Sider, Content} = Layout;


class SimulationData extends Component {
    state = {
        activeKeys: [],
        productTypeNames: {},
        productSiteItems: [],
        defaultSelectKey: null,
        defaultOpenKey: null,


        meetOrders: [],
        meetOrder: '空基十二五光学卫星数据仿真',
        simNum: '空基十二五光学卫星数据仿真sim1',
        SimulationData: {},
        modalVisible: false
    }
    meetOrders = ['空基十二五光学卫星数据仿真', '空基十三五光学卫星数据仿真','空基十三五微波卫星数据仿真']

    componentDidMount() {
        this._getSimulationData().then(r => {})
    }

    /**
     * 组织仿真卫星数据
     * @param simData
     * @private
     */
    _organizeData = (simData) => {
        const organizedData = {};

        // 遍历所有 meetOrder 数据
        simData.forEach(meetData => {
            const meetOrder = meetData.meetOrder;

            // 初始化 meetOrder 的数据结构
            if (!organizedData[meetOrder]) {
                organizedData[meetOrder] = {};
            }

            // 遍历每个 simNum
            meetData.data.forEach(simDataItem => {
                // const simNum = simDataItem.simNum;
                const simNum = `${meetOrder}${simDataItem.simNum}`;
                // 初始化 simNum 的数据结构
                if (!organizedData[meetOrder][simNum]) {
                    organizedData[meetOrder][simNum] = [];
                }

                // 遍历每个 satelite
                simDataItem.data.forEach(sateliteData => {
                    const satelite = sateliteData.satelite;
                    const sateliteInfo = {
                        satelite: satelite,
                        data: [] // 用于存储该卫星的所有数据
                    };

                    // 遍历每个卫星的相机数据
                    sateliteData.data.forEach(cameraData => {
                        sateliteInfo.data.push({
                            cameraBand: cameraData.cameraBand,
                            downloadUrl: cameraData.downloadUrl,
                            imageUrl: cameraData.imageUrl,
                            id: cameraData.id
                        });
                    });

                    // 将每个卫星的信息加入到相应的 simNum 下
                    organizedData[meetOrder][simNum].push(sateliteInfo);
                });
            });
        });
        // console.log('数据格式', organizedData);
        this.setState({SimulationData: organizedData})
    }
    /**
     * 获取卫星仿真数据
     * @returns {Promise<void>}
     * @private
     */
    _getSimulationData = async () => {
        getAllSimulationData().then(res => {
            this._organizeData(res.payload)
        }).catch(error => {
            console.error(`Error fetching product name for :`, error);
        })
    }

    _downloadClicked = (downloadUrl) => {
        console.log('下载链接', downloadUrl);
        // let downLoadUrl = global.support.fileServer+'/'+ value.url + `?filename=${value.fileName}`
        // let downLoadUrl = value.url + `?filename=${value.fileName}`
        //
        // putDownloadOderRecords([{
        //     fileName: value.fileName,
        //     orderCreationUserId: this.props.user.userId,
        //     orderDownloadAddr: downLoadUrl,
        //     resourceType: "样例数据下载"
        // }]).then(data => {
        //         if (data.code === '200') {
        //             message.success('下载订单提交成功!')
        //             //     此处添加下载成功后的逻辑
        //         }
        //     }
        // )
        //
        const link = document.createElement('a');
        link.href = downloadUrl;
        // link.download = value.fileName; // 设置下载文件的默认名称
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        message.info('数据开始下载!').then(r => {})
    }

    renderSimulationDataItem = () => {
        const {SimulationData, meetOrder, simNum} = this.state
        // console.log('具体数据',SimulationData[meetOrder]['空基十二五光学卫星数据仿真sim1']);
        return Object.keys(SimulationData).length > 0 ? SimulationData[meetOrder][simNum].map((value) => {
            return (
                <div className="baotou_data_Item baotou_data_Item_hoverable" key={value.satelite}>
                    <div className="baotou_item_title">
                        <div className="baotou_item_title_icon"></div>
                        {value.satelite}
                    </div>
                    <hr className="hr_line"/>
                    <div className="baotou_item_body">
                        {value.data.map((value) => {
                            return (
                                // <Tooltip title="点击下载" key={value.id}>
                                <div key={value.id} className="camera_data_item">
                                    <img className="sim_image" src={value.imageUrl} alt=""/>
                                    <div className="camera_download_box">
                                        <div className="camera_text">{value.cameraBand}</div>
                                        <Button
                                            onClick={() => this._downloadClicked(value.downloadUrl)}
                                            type="primary" size="small">点击下载
                                        </Button>
                                    </div>
                                </div>
                                // </Tooltip>
                            )
                        })}
                    </div>
                </div>
            )
        }) : []
    }

    renderManuItem = () => {
        const productTypeNames = ['sim1', 'sim2']
        const sim_name = {'sim1': '第一次数据仿真', 'sim2': '第二次数据仿真'}
        return Object.keys(productTypeNames).length !== 0 ? this.meetOrders.map((meetOrder) => {
            return (
                <Menu.SubMenu key={meetOrder} title={meetOrder}>
                    {
                        productTypeNames.length > 0 ? productTypeNames.map((simNum, index) => {
                            return <Menu.Item key={meetOrder + simNum}>{sim_name[simNum]}</Menu.Item>;
                        }) : null
                    }
                </Menu.SubMenu>
            );
        }) : null;
    }

    _getSiteNames = (e) => {
        let simNum = e.keyPath[0], meetOrder = e.keyPath[1]
        console.log({meetOrder: meetOrder, simNum: simNum})
        this.setState({meetOrder: meetOrder, simNum: simNum})
    }


    _openPDFModal = () => {
        this.setState({modalVisible: true})
    }

    render() {
        return (
            <div className="baotou_page">
                <Header4/>
                <div className="baotou_main">
                    <Layout className="baotou_layout">
                        <Sider theme="light" className="baotou_sider" width={250}>
                            <Menu
                                mode="inline"
                                style={{
                                    height: '100%',
                                }}
                                onClick={this._getSiteNames}
                                // defaultOpenKeys={['陆表类']}
                                // defaultSelectedKeys={[this.state.defaultSelectKey]}
                                // defaultSelectedKeys={['土地覆盖']}
                            >
                                {this.renderManuItem()}
                            </Menu>
                        </Sider>
                        <Content className="baotou_content">
                            {this.state.meetOrder === '空基十三五光学卫星数据仿真' ?

                                <Tooltip title="点击预览数据说明文档">
                                    <Button className="download_button" onClick={this._openPDFModal} visible={false}
                                            icon={<FilePdfOutlined/>}></Button>
                                </Tooltip> : ""
                            }
                            <div className="baotou_item_box">
                                {this.renderSimulationDataItem()}
                            </div>
                        </Content>
                    </Layout>
                    <Modal visible={this.state.modalVisible} footer={null}
                           onCancel={() => this.setState({modalVisible: false})}
                           destroyOnClose={true} width={1000}
                    >
                        <iframe className="pdf_iframe"
                                src="https://caplos.aircas.ac.cn/oss/group1/M00/1E/47/rBIAB2eJVvaAPgpcAc6BkCvQSiM136.pdf"></iframe>
                    </Modal>
                </div>
            </div>
        )
    }
}

const mapState = (state) => ({
    loginObj: state.userReducer.get("loginObj").toJS(),
    user: state.userReducer.get("user").toJS(),
});
const mapDispatch = (dispatch) => ({});

export default connect(mapState, mapDispatch)(SimulationData);